export default __webpack_public_path__ + "static/media/3531.366eac04.png";